import React from 'react';

import { Props } from './CheckboxField.types';
import styles from './CheckboxField.module.scss';
import InputWrapper from '../InputWrapper/InputWrapper';

const Checkbox: React.FC<Props> = ({ field, disabled, title, subtitle, onClick, extraContent = [], variant }) => {
  field.value = field.value || false;

  return (
    <InputWrapper
      title={variant === 'inline' ? '' : title}
      name={field.name}
      subtitle={subtitle}
      hasError={false}
      wasTouched={false}
      extraContent={extraContent}>
      <div className={styles.wrapper}>
        <input type="checkbox" id={field.name} {...field} checked={field.value} disabled={disabled} onClick={onClick} />
        <label
          className={styles.checkbox}
          htmlFor={field.name}
          style={disabled ? { background: '#e5e5e5' } : { background: '#fff' }}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 26">
            <path d="M12.05 25.822L.29 14.052l3.54-3.54 8.23 8.23L30.29.512l3.54 3.54z" />
          </svg>
        </label>
        {variant === 'inline' && (
          <label htmlFor={field.name} className={`${styles.label} ${styles.inline}`}>
            {title}
          </label>
        )}
      </div>
    </InputWrapper>
  );
};

export default Checkbox;
